// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"5":"Likes","265":"Index","383":"Publication","406":"User","532":"Notify","589":"PublicationGet","592":"AccountEdit","716":"Account","771":"PublicationNew","939":"PublicationEdit"}[chunkId] || chunkId) + "@desktop.js";
};